// @flow

import _ from 'lodash';

import { store } from 'src/stores/store';

/**
 * Get app admin feature
 *
 * @param  {string} name feature name
 *
 * @return {boolean}      true | false
 */
export function getAppAdminFeatures(name) {
  const currentState = store.getState();
  const adminAppFeatures = _.get(currentState.oauth.tenantApp, 'adminAppFeatures', {});
  const featureFlag = _.get(adminAppFeatures, name, false);

  return featureFlag;
}

/**
 * Get app admin feature
 *
 * @param  {string} name feature name
 *
 * @return {boolean}      true | false
 */
export function getFeatures(name) {
  const currentState = store.getState();
  const features = _.get(currentState.oauth.tenantApp, 'features', {});
  const featureFlag = _.get(features, name, false);

  return featureFlag;
}
